import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { Tabs } from 'react-science/ui';
import { CheckBoxCell } from '../../../elements/CheckBoxCell';
import IsotopesViewer from '../../../elements/IsotopesViewer';
import ReactTable from '../../../elements/ReactTable/ReactTable';
function OnLoadProcessingTabContent() {
    const { values } = useFormikContext();
    const [activeTab, setActiveTab] = useState('1H');
    const tabItems = Object.keys(values?.onLoadProcessing || {}).map((nucleus) => ({
        id: nucleus,
        title: _jsx(IsotopesViewer, { value: nucleus }),
        content: (_jsx(FiltersTable, { data: values?.onLoadProcessing?.[nucleus], nucleus: nucleus })),
    }));
    return (_jsx("div", { style: { width: '100%', overflow: 'hidden' }, children: _jsx(Tabs, { items: tabItems, opened: activeTab, onClick: (id) => setActiveTab(id) }) }));
}
function FiltersTable({ data, nucleus }) {
    const COLUMNS = [
        {
            index: 1,
            Header: '#',
            accessor: (_, index) => index + 1,
        },
        {
            index: 1,
            Header: 'Filter',
            accessor: 'label',
            style: { width: '60%' },
        },
        {
            index: 2,
            Header: 'Enable',
            Cell: ({ row }) => (_jsx(CheckBoxCell, { name: `onLoadProcessing.${nucleus}.${row.index}.flag`, defaultValue: false })),
        },
    ];
    return _jsx(ReactTable, { columns: COLUMNS, data: data });
}
export default OnLoadProcessingTabContent;
